import React from 'react';
import { ListGroup, ListGroupItem, Button } from 'reactstrap';
import logger from './logHelper';
import i18n from '../i18n/config';
const { t } = i18n;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: ''
    };
  }

  componentDidCatch(error, info) {
    const msg = error + (info.componentStack || '');
    this.setState({ hasError: true });
    logger.logError(msg);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 10 }}>
          <ListGroup>
            <ListGroupItem color='danger'>
              {t('label.something_went_wrong')}{' '}
              <span>
                <Button
                  style={{ float: 'right' }}
                  onClick={() => window.location.reload()}
                >
                  {t('button.reload')}
                </Button>
              </span>
            </ListGroupItem>
          </ListGroup>
        </div>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
